import React, { useCallback, useState } from 'react';
import { ZAvatar, useApiClient } from '@marageti/z4-lib';
import { Agent } from '@marageti/z4-sdk/lib/people';
import { enqueueSnackbar } from 'notistack';

type UserProfileAvatarProps = {
  agent: Agent;
  agentMutateHandler: (updatedAgent: Agent) => void;
};

const UserProfileAvatar = ({
  agent,
  agentMutateHandler,
}: UserProfileAvatarProps) => {
  const [avatarLoading, setIsAvatarLoading] = useState<boolean>(false);
  const apiClient = useApiClient();
  const {
    id: agentId, avatar, fullName,
  } = agent || {};

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onUpdateAvatar = useCallback(
    async (base64Img: string) => {
      try {
        setIsAvatarLoading(true);
        const updatedAgent = await apiClient.peopleClient.putAgentAvatar(
          agentId,
          { id: agentId, avatar: base64Img },
        );
        agentMutateHandler(updatedAgent);
      } catch (error: any) {
        // eslint-disable-next-line no-console
        console.error('Error updating avatar:', error);
        enqueueSnackbar('The image could not be uploaded', { variant: 'default' });
      } finally {
        setIsAvatarLoading(false);
      }
    },
    [agent?.id, apiClient, setIsAvatarLoading],
  );

  return (
    <ZAvatar
      src={avatar}
      alt={fullName}
      name={fullName}
      loading={!agentId || avatarLoading}
      size={128}
      onEdit={onUpdateAvatar}
    />
  );
};

export default UserProfileAvatar;
